import { apiPOST } from './networking';

/**
 *
 * @param {string} questionText
 * @returns {{ __html: string }}
 */
export function createMarkup(questionText) {
  return {
    __html: questionText,
  };
}

/**
 * @typedef {{ isAvailable:Boolean; email:string; }} TEmailAvailabilityResult
 */

/**
 *
 * @param {{ emailAddress?:string, userName?:string }} payload
 * @param {string} url
 * @returns {Promise<TEmailAvailabilityResult>}
 */
const emailAvailability = (payload, url) =>
  new Promise((resolve) =>
    apiPOST(url, payload)
      .then((response) => {
        return resolve({ email: payload.emailAddress ?? payload.userName ?? '', isAvailable: !response.body, });
      })
  );

const _usedAccountsCache = /** @type {Map<String, TEmailAvailabilityResult>} */(new Map([["", { email: '', isAvailable: false }]]));
/**
 *
 * @param {string} email
 * @returns {Promise<TEmailAvailabilityResult>}
 */
export const runEmailAvailabilityCheck = async (email) => {
  const emailURL = '/recommendation/rest/profile/emailAvailability';
  const usernameURL = '/recommendation/rest/profile/userNameAvailability';
  const results = _usedAccountsCache.has(email) ? /** @type {TEmailAvailabilityResult} */(_usedAccountsCache.get(email)) : await Promise.all([
    emailAvailability({ emailAddress: email }, emailURL),
    emailAvailability({ userName: email }, usernameURL),
  ]).then((results) => ({ isAvailable: results[0].isAvailable && results[1].isAvailable, email, }));
  _usedAccountsCache.set(email, results);
  return results;
};
